module.exports = "<app-tab-profil [profilIn]=\"profil\"></app-tab-profil>"